import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'grupo-atualizacao';
const route = {
  listar: `${baseRef}/combo`
};

@Injectable({
  providedIn: 'root'
})
export class GrupoAtualizacaoService {

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) { }

  listar(): Observable<any> {
    return this.domainCache.getOrLoad(route.listar, () =>
      this.apiService.get<any>(`${route.listar}`, undefined, undefined, true)
    );
  }
}
